import React, { useEffect, useState } from "react";
import ImportWizard from "./ImportWizard";
import AddContactsFlow from "./AddContactsFlow";
import ImportHistory from "./ImportHistory";
import ActivityLog from "./ActivityLog";
import { useImportApi } from "./importApi";
import "./Import.css";

// Import tab container: "New Import" wizard, "Add Contacts" (red lists →
// existing leads) + "Import History", plus the
// admin-only "Activity Log" (shown only when GET /import/me says is_admin —
// the server also refuses the log to everyone else).
// Both sub-views stay mounted (hidden via CSS) so an in-progress wizard or a
// polling batch isn't lost when flipping between them.
export default function ImportPanel({ active = true, handoff = null }) {
	const api = useImportApi();
	const [view, setView] = useState("new"); // "new" | "contacts" | "history" | "activity"
	const [historyFocusBatch, setHistoryFocusBatch] = useState(null);
	const [isAdmin, setIsAdmin] = useState(false);

	useEffect(() => {
		let cancelled = false;
		api
			.getMe({ quiet: true })
			.then((me) => {
				if (!cancelled) setIsAdmin(Boolean(me?.is_admin));
			})
			.catch(() => {
				/* not signed in / not authorized: keep the tab hidden */
			});
		return () => {
			cancelled = true;
		};
	}, [api]);

	// A list handed over from the scrub results panel: green → the new-lead
	// wizard, red → Add Contacts.
	useEffect(() => {
		if (!handoff) return;
		setView(handoff.kind === "contacts" ? "contacts" : "new");
	}, [handoff]);

	const openHistory = (batchId) => {
		setHistoryFocusBatch(batchId ?? null);
		setView("history");
	};

	return (
		<div className="importPanel">
			<h1>📥 Iris Lead Importer</h1>

			<div className="importTabs">
				<button
					type="button"
					className={`importTabBtn ${view === "new" ? "active" : ""}`}
					onClick={() => setView("new")}>
					New Import
				</button>
				<button
					type="button"
					className={`importTabBtn ${view === "contacts" ? "active" : ""}`}
					onClick={() => setView("contacts")}>
					Add Contacts
				</button>
				<button
					type="button"
					className={`importTabBtn ${view === "history" ? "active" : ""}`}
					onClick={() => setView("history")}>
					Import History
				</button>
				{isAdmin && (
					<button
						type="button"
						className={`importTabBtn ${view === "activity" ? "active" : ""}`}
						onClick={() => setView("activity")}>
						Activity Log
					</button>
				)}
			</div>

			<div style={{ display: view === "new" ? "block" : "none" }}>
				<ImportWizard
					onViewHistory={openHistory}
					handoff={handoff?.kind === "leads" ? handoff : null}
				/>
			</div>
			<div style={{ display: view === "contacts" ? "block" : "none" }}>
				<AddContactsFlow
					api={api}
					onViewHistory={openHistory}
					handoff={handoff?.kind === "contacts" ? handoff : null}
				/>
			</div>
			<div style={{ display: view === "history" ? "block" : "none" }}>
				<ImportHistory
					active={active && view === "history"}
					focusBatchId={historyFocusBatch}
				/>
			</div>
			{isAdmin && (
				<div style={{ display: view === "activity" ? "block" : "none" }}>
					<ActivityLog active={active && view === "activity"} />
				</div>
			)}
		</div>
	);
}
